import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  ContentBox,
  CustomFilterAddress,
  CustomFilterData,
  CustomFilterLastFirstName,
  CustomFilterSelect,
  CustomFilterText,
  CustomHeaderFormatter,
  CustomSort,
  CustomSortData,
  LoaderTable,
  ShowTitleTable,
  TableCellEmployeeTrainingsStatus,
  TableCellListToCell,
  TableCellTypeTrainings,
  TablePagination,
  TableRecordAction,
} from 'components';
import { LoyaltyRepository } from 'api/repository';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { customFilter } from 'react-bootstrap-table2-filter';
import { useHistory } from 'react-router-dom';
import TrainingsType from 'constants/Trainings';

const TableTrainingsBlock = (): ReactElement => {
  const { t } = useTranslation(['trainingsGroup', 'trainings']);
  const history = useHistory();

  const getStorageTableData = () => {
    const data = window.sessionStorage.getItem('administrationLoyaltyTable');
    if (data === null) {
      return null;
    }
    return JSON.parse(data);
  };

  const storageTable = getStorageTableData();

  const [page, setPage] = React.useState(
    storageTable === null ? 1 : storageTable.pageNumber + 1
  );
  const [loaderTable, setLoaderTable] = useState<boolean>(false);

  // variable search

  const mapSearch: { [key: string]: string } = {
    firstName: 'firstName',
    lastName: 'lastName',
  };

  const getFilterData = (): { [key: string]: string } => {
    if (storageTable === null) {
      return {};
    }
    let newSort = {} as { [key: string]: string };
    Object.keys(mapSearch).forEach((v) => {
      if (storageTable?.[mapSearch?.[v]]) {
        newSort = {
          ...newSort,
          [mapSearch?.[v]]: storageTable?.[mapSearch?.[v]],
        };
      }
    });
    return newSort;
  };
  const [filterReq, setFilterReq] = useState<{ [key: string]: string }>(
    getFilterData()
  );

  // End variable search

  // variable order
  const getOrderData = (): string => {
    if (storageTable === null) {
      return JSON.stringify({
        LAST_NAME: 'default',
        order: 'asc',
      });
    }

    let newOrder = {
      LAST_NAME: 'default',
      order: storageTable.ascending ? 'asc' : 'desc',
    } as { [key: string]: string };
    if (storageTable.sort) {
      newOrder = { ...newOrder, name: storageTable.sort };
    }
    return JSON.stringify(newOrder);
  };

  const [orderColumn, setOrderColumn] = useState<string>(getOrderData());
  const mapOrder: { [key: string]: string } = {
    name: 'default',
  };
  // end variable order
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [getData, data] = LoyaltyRepository.useGetAllLoyalty();

  const [updateDataTable, setUpdateDataTable] = useState<number>(0);

  const [modalShow, setModalShow] = useState<boolean>(false);
  const [modalId, setModalId] = useState<number>(0);

  const [modalSelect, setModalSelect] = useState<boolean>(false);

  useEffect(() => {
    setLoaderTable(true);
    const paramQuery = {
      pageNumber: page - 1,
      pageSize: rowsPerPage,
    };

    Object.keys(filterReq).forEach((key) => {
      if (filterReq[key] !== '') {
        Object.assign(paramQuery, { [key]: filterReq[key] });
      }
    });
    const getOrderColumn = JSON.parse(orderColumn);
    if (getOrderColumn.name !== 'default') {
      Object.assign(paramQuery, { sort: getOrderColumn.name });
    }
    if (getOrderColumn.order === 'asc') {
      Object.assign(paramQuery, { ascending: true });
    } else {
      Object.assign(paramQuery, { ascending: false });
    }

    window.sessionStorage.setItem(
      'administrationLoyaltyTable',
      JSON.stringify(paramQuery)
    );

    getData(paramQuery);
  }, [getData, page, rowsPerPage, filterReq, orderColumn, updateDataTable]);

  useEffect(() => {
    if (data !== null) {
      setLoaderTable(false);
    }
  }, [data]);

  const dataCustomFilterData = (objSearch: { [key: string]: string }) => {
    CustomFilterData({
      filterReq,
      objSearch,
      mapSearch,
      setFilterReq,
      setUpdateDataTable,
      setPage,
    });
  };

  const onTableChange = (type: any, newState: any) => {
    if (type === 'sort') {
      CustomSortData({
        orderColumn,
        newState,
        mapOrder,
        setOrderColumn,
        setUpdateDataTable,
      });
    }
  };

  const typeOptions = () => {
    const arrayTypeOption = [] as any;
    Object.keys(TrainingsType).forEach((key) => {
      arrayTypeOption.push({
        value: TrainingsType[key],
        label: t(`trainings:trainingsTypeEnum.${TrainingsType[key]}`),
      });
    });
    return arrayTypeOption;
  };

  const columns = [
    {
      dataField: '',
      text: '',
      headerClasses: 'firstCellAction',
      formatter: (cell: any, row: any, rowIndex: any, formatExtraData: any) => {
        return (
          <TableRecordAction
            dataId={row.id}
            editClick={() => {
              history.push(`/administracja/umowy-lojalnosciowe/${row.id}`);
            }}
            rowNumber={rowIndex}
            page={page}
            rowsPerPage={rowsPerPage}
          />
        );
      },
    },
    {
      dataField: 'name',
      text: 'Nazwisko i imię',
      sort: true,
      sortCaret: (order: any, column: any) => <CustomSort order={order} />,
      sortOrder: 'asc',
      // @ts-ignore
      filter: customFilter(),
      filterRenderer: (onFilter: any, column: any) => (
        <CustomFilterLastFirstName
          customFilter={dataCustomFilterData}
          column={column}
          firstNameDefault={filterReq?.firstName || undefined}
          lastNameDefault={filterReq?.lastName || undefined}
        />
      ),
      headerFormatter: (
        column: any,
        index: any,
        { sortElement, filterElement }: { sortElement: any; filterElement: any }
      ) => {
        return (
          <CustomHeaderFormatter
            column={column}
            sortElement={sortElement}
            filterElement={filterElement}
            moveOverAction
          />
        );
      },
    },
    {
      dataField: 'generationDate',
      text: 'Data wygenerowania',
      align: 'center',
      sortCaret: (order: any, column: any) => <CustomSort order={order} />,
      headerFormatter: (
        column: any,
        index: any,
        { sortElement, filterElement }: { sortElement: any; filterElement: any }
      ) => {
        return (
          <CustomHeaderFormatter
            column={column}
            sortElement={sortElement}
            filterElement={filterElement}
            align="center"
          />
        );
      },
    },
    {
      dataField: 'handoverDate',
      text: 'Data wysłania',
      align: 'center',
      sortCaret: (order: any, column: any) => <CustomSort order={order} />,
      headerFormatter: (
        column: any,
        index: any,
        { sortElement, filterElement }: { sortElement: any; filterElement: any }
      ) => {
        return (
          <CustomHeaderFormatter
            column={column}
            sortElement={sortElement}
            filterElement={filterElement}
            align="center"
          />
        );
      },
    },
    {
      dataField: 'returnDate',
      text: 'Data zwrotu',
      align: 'center',
      sortCaret: (order: any, column: any) => <CustomSort order={order} />,
      headerFormatter: (
        column: any,
        index: any,
        { sortElement, filterElement }: { sortElement: any; filterElement: any }
      ) => {
        return (
          <CustomHeaderFormatter
            column={column}
            sortElement={sortElement}
            filterElement={filterElement}
            align="center"
          />
        );
      },
    },
    {
      dataField: 'expirationDate',
      text: 'Data końca',
      align: 'right',
      sortCaret: (order: any, column: any) => <CustomSort order={order} />,
      headerFormatter: (
        column: any,
        index: any,
        { sortElement, filterElement }: { sortElement: any; filterElement: any }
      ) => {
        return (
          <CustomHeaderFormatter
            column={column}
            sortElement={sortElement}
            filterElement={filterElement}
            align="right"
          />
        );
      },
    },
  ];

  return (
    <>
      <ContentBox id="administrationLoyaltyTable" noPadding>
        <Box
          id="loyaltyTableBox"
          name="UMOWA LOJALNOŚCIOWA"
          svgIcon="loyaltyIcon"
          noPadding
        >
          <LoaderTable active={loaderTable} noRadiusTop>
            <>
              <TablePagination
                rowInPage={rowsPerPage}
                page={page}
                changeRowInPage={setRowsPerPage}
                data={data}
                changePage={setPage}
              >
                <ShowTitleTable
                  id="titleTableEmployee"
                  label="Lista pracowników posiadających umowy lojalnościowe, lub wymagających ich podpisania:"
                />
              </TablePagination>
              <BootstrapTable
                bootstrap4
                hover
                bordered={false}
                keyField="id"
                data={data?.content || []}
                columns={columns}
                noDataIndication="Brak umów lojalnościowych"
                remote={{
                  filter: true,
                  sort: true,
                }}
                onTableChange={onTableChange}
                filter={filterFactory()}
                defaultSorted={[
                  {
                    dataField: JSON.parse(orderColumn)?.name
                      ? JSON.parse(orderColumn)?.name.toLowerCase()
                      : 'name',
                    order:
                      JSON.parse(orderColumn)?.order === 'desc'
                        ? 'desc'
                        : 'asc',
                  },
                ]}
              />
              <TablePagination
                rowInPage={rowsPerPage}
                page={page}
                changeRowInPage={setRowsPerPage}
                data={data}
                changePage={setPage}
              />
            </>
          </LoaderTable>
        </Box>
      </ContentBox>
    </>
  );
};

export default TableTrainingsBlock;
